import { render, staticRenderFns } from "./ProductsAnalytics.html?vue&type=template&id=0aa84300&scoped=true&external"
import script from "./ProductsAnalytics.js?vue&type=script&lang=js&external"
export * from "./ProductsAnalytics.js?vue&type=script&lang=js&external"
import style0 from "./ProductsAnalytics.vue?vue&type=style&index=0&id=0aa84300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa84300",
  null
  
)

export default component.exports